import { FunctionComponent } from 'react';
import { BackButton, useIsFollowAllowed } from '../../shared';
import { NoContent } from '../Error';
import { MyTopicsContent } from './MyTopicsContent';

import classes from './MyTopics.module.scss';

export const MyTopics: FunctionComponent = () => {
  const isFollowAllowed = useIsFollowAllowed();

  if (!isFollowAllowed) {
    return <NoContent />;
  }

  return (
    <div className={classes['my-topics']}>
      <BackButton />

      <MyTopicsContent />
    </div>
  );
};
